<template>
    <div v-if="show">
        <div class="scroll-wrapper">
            <div v-if="isBuddycomAccountSelected">
                <el-table
                    :data="this.objectDataList.users"
                    border
                    class="object-table"
                    style="width: max-content"
                    :height="tableHeight"
                    :key="'usersTable'"
                    :default-sort="{ prop: 'name', order: 'ascending' }"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="50" fixed/>
                    <template v-for="(column) in tableViewColumns.buddycomAccount" :key="column.prop">
                        <el-table-column v-if="column.prop === 'existsToken' && column.visible" :label="column.label" :width="column.width" :sortable="true" :sort-method="sortExistsToken">
                            <template slot-scope="scope">
                                {{ scope.row.existsToken ? '使用中' : '未使用' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else-if="column.visible"
                            :prop="column.prop"
                            :label="column.label"
                            :width="column.width"
                            :sortable="true"
                            :sort-method="(a,b) => sortStringWithNumber(a,b, column.prop)">
                            <template slot-scope="scope">
                                {{ formatDisplay(scope.row[column.prop], column, scope.row) }}
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column
                        fixed="right"
                        label="詳細"
                        width="60">
                        <template slot-scope="scope">
                            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">詳細</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="isGroupSelected">
                <el-table
                    :data="this.objectDataList.talkGroups"
                    border
                    class="object-table"
                    style="width: max-content"
                    :height="tableHeight"
                    :key="'groupTable'"
                    :default-sort="{ prop: 'name', order: 'ascending' }"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="50" fixed/>
                    <template v-for="(column) in tableViewColumns.group">
                        <el-table-column
                            v-if="column.visible"
                            :prop="column.prop"
                            :label="column.label"
                            :width="column.width"
                            :key="column.prop"
                            sortable
                            :sort-method="(a,b) => sortStringWithNumber(a,b, column.prop)">
                            <template slot-scope="scope">
                                {{ formatDisplay(getGroupColumnValue(scope.row, column.prop), column) }}
                            </template>
                        </el-table-column>
                    </template>

                    <el-table-column
                        fixed="right"
                        label="詳細"
                        width="60">
                        <template slot-scope="scope">
                            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">詳細</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="isIpRadioAccountSelected">
                <el-table
                    ref="ipRadioTable"
                    :data="this.objectDataList.ipRadios"
                    border
                    class="object-table"
                    style="width: max-content"
                    :height="tableHeight"
                    row-key="id"
                    reserve-selection
                    :key="'ipRadioTable'"
                    :default-sort="{ prop: 'name', order: 'ascending' }"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="50" fixed/>
                    <template v-for="(column) in tableViewColumns.ipRadio">
                        <el-table-column v-if="column.prop === 'existsToken' && column.visible" :label="column.label" :width="column.width" :sortable="true" :sort-method="sortExistsToken" :key="column.prop">
                            <template slot-scope="scope">
                                {{ scope.row.existsToken ? '使用中' : '未使用' }}
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="column.prop === 'primaryLine' && column.visible" :label="column.label" :width="column.width" :sortable="true" :sort-method="(a,b) => sortStringWithNumber(a,b, column.prop)" :key="column.prop">
                            <template slot-scope="scope">
                                {{ getPrimaryLineDisplay(scope.row.primaryLine) || '' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-else-if="column.visible"
                            :prop="column.prop"
                            :label="column.label"
                            :width="column.width"
                            :key="column.prop"
                            sortable
                            :sort-method="(a,b) => sortStringWithNumber(a,b, column.prop)">
                            <template slot-scope="scope">
                                {{ formatDisplay(scope.row[column.prop], column, scope.row) }}
                            </template>
                        </el-table-column>
                    </template>

                    <el-table-column
                        fixed="right"
                        label="詳細"
                        width="60">
                        <template slot-scope="scope">
                            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">詳細</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="tableDisplayNumberByPage"
            :current-page="currentPage"
            @current-change="handlePageChange">
        </el-pagination>
    </div>
</template>

<script>
import constants from './constants.js';
import commonUtil from './commonutil.js';
import commonutil from "./commonutil.js";

export default {
    data() {
        return {
            TABLE_OPTIONS: constants.TABLE_OPTIONS,
            tableDisplayNumberByPage: constants.TABLE_DISPLAY_NUMBER_BY_PAGE,
            tableHeight: 'calc(100vh - 250px)',
            total: 0,
            show: true,
        };
    },
    methods: {
        getPrimaryLineDisplay(key) {
            return commonUtil.getIpRadioPrimaryLine(key);
        },
        sortExistsToken(a, b) {
            // true を「使用中（上位）」、false を「未使用（下位）」とする
            return (a.existsToken === b.existsToken) ? 0 : a.existsToken ? -1 : 1;
        },
        getGroupColumnValue(row, key) {
            if (key === 'storageName') {
                return commonUtil.getTalkgroupStorageDisplayName(
                    this.$i18n,
                    row?.processorDefinitionIds,
                    this.$root.store.processorDefinitionList
                );
            }
            return row?.[key];
        },
        sortStringWithNumber(a, b, key) {
            const sourceA = (this.isGroupSelected && key === 'storageName') ? this.getGroupColumnValue(a, key) : a[key];
            const sourceB = (this.isGroupSelected && key === 'storageName') ? this.getGroupColumnValue(b, key) : b[key];
            const valA = sourceA != null ? sourceA.toString() : '';
            const valB = sourceB != null ? sourceB.toString() : '';
            return commonUtil.compareStringWithNumber(valA, valB);
        },
        formatDisplay(value, column, row) {
            if (column?.prop === 'tokenCreateDate') {
                if (!row?.existsToken) {
                    return '-';
                }

                const tokenCreateDate = new Date(value);
                if (Number.isNaN(tokenCreateDate.getTime())) {
                    return value;
                }
                if (tokenCreateDate.getTime() < Date.UTC(2021, 9, 14, 18, 0, 0)) {
                    return commonUtil.getMessageText(this.$i18n, 'info_no_available_use_start_date');
                }

                return tokenCreateDate.toLocaleString();
            }
            if (column?.prop === 'settingName') {
                const normalizedValue = typeof value === 'string' ? value.trim() : value;
                if (
                    normalizedValue === null ||
                    normalizedValue === undefined ||
                    normalizedValue === '' ||
                    normalizedValue === 0 ||
                    normalizedValue === '0'
                ) {
                    return '未割り当て';
                }
            }
            if (value === null || value === undefined || value === '') {
                return value; // nullや空文字はそのまま
            }
            if (column?.prop === 'saveVoice') {
                return value ? '保存する' : '保存しない';
            }
            if (column?.prop === 'interrupt') {
                return value ? 'あり' : 'なし';
            }
            if (typeof value === 'boolean') {
                return value ? '利用中' : '利用しない';
            }
            if (column && column.prop === 'version') {
                return commonUtil.formatIpRadioVersionForDisplay(value);
            }
            if (typeof value === 'number' || typeof value === 'string') {
                return value;
            }
            return value;
        },
        reload() {
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
                this.$nextTick(() => {
                    this.applyIpRadioPreselection();
                });
            });
        },
        applyIpRadioPreselection() {
            try {
                const rows = this.objectDataList?.ipRadios || [];
                const tableComp = this.$refs.ipRadioTable;
                console.log("[ObjectTable] applyIpRadioPreselection called. tab=", this.isIpRadioAccountSelected, "rows=", rows.length, "tableRef=", !!tableComp);
                if (!this.forceIpRadioPreselect) return;
                // 条件: IP無線機タブが選択され、テーブル参照がある場合のみ
                if (!this.isIpRadioAccountSelected) return;
                if (!tableComp || typeof tableComp.clearSelection !== 'function') return;
                if (!Array.isArray(rows) || rows.length === 0) return;

                // テーブルの行 DOM が完全に描画された後に適用するため、nextTick を二段重ねにする
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        try {
                            tableComp.clearSelection();
                            rows.forEach(row => {
                                if (typeof tableComp.toggleRowSelection === 'function') {
                                    tableComp.toggleRowSelection(row, true);
                                }
                            });
                            console.debug("[ObjectTable] preselection applied (select all current ipRadios). count=", rows.length);
                        } catch(e) { /* no-op */ }
                    });
                });
            } catch(e) { /* no-op */ }
        },
        handleSelectionChange(val) {
            this.$emit('select', val, this.selectedTableOption.value);
        },
        totalChange(){
            if(this.selectedTableOption.value == this.TABLE_OPTIONS.buddycomAccount.value){
                this.total = this.objectDataList.maxUserTotal;
            }else if(this.selectedTableOption.value == this.TABLE_OPTIONS.group.value){
                this.total = this.objectDataList.maxTalkGroupTotal;
            }else if(this.selectedTableOption.value == this.TABLE_OPTIONS.ipRadioAccount.value){
                this.total = this.objectDataList.maxIpRadioTotal;
            }else{
                this.total = 0;
            }
        },
        handlePageChange(val){
            this.$emit('pageChange', val, this.selectedTableOption.value);
        },
        handleDetailClick(row){
            this.$emit('detailClick', row, this.selectedTableOption.value);
        }
    },
    created: function () {
    },
    computed: {
        commonutil() {
            return commonutil
        },
        isBuddycomAccountSelected() {
            console.log(this.objectDataList);
            return (
                this.TABLE_OPTIONS &&
                this.selectedTableOption?.value === this.TABLE_OPTIONS.buddycomAccount.value
            )
        },
        isGroupSelected() {
            return (
                this.TABLE_OPTIONS &&
                this.selectedTableOption?.value === this.TABLE_OPTIONS.group?.value
            );
        },
        isIpRadioAccountSelected() {
            return (
                this.TABLE_OPTIONS &&
                this.selectedTableOption?.value === this.TABLE_OPTIONS.ipRadioAccount?.value
            );
        }
    },

    watch: {
        objectDataList: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.totalChange();
            },
        },
        selectedTableOption: {
            immediate: true,
            handler(newVal) {
                this.totalChange();
            },
        },
        tableViewColumns: {
            deep: true,
            handler() {
                this.reload();
            },
        },
    },

    mounted() {
        // 初回描画直後でも一度は適用を試みる
        this.$nextTick(() => {
            this.applyIpRadioPreselection();
        });
    },

    props: [
        'objectDataList',
        'selectedTableOption',
        'tableViewColumns',
        'appData',
        'forceIpRadioPreselect',
        'currentPage',
    ]
}

</script>

<style scoped>

.scroll-wrapper {
    width: 100%;
    overflow: visible;
}

.object-table {
    font-size: 12px;
    table-layout: fixed;
}

::v-deep(.object-table thead th) {
    background-color: #EAEAEA;
    color: #4F4F4F;
}

::v-deep(.object-table .el-table__cell) {
    text-align: center;
    padding: 3px 0;
    white-space: nowrap;
}

</style>
